module.exports = __webpack_public_path__ + "img/stepp_logo_w.e8af5b59.png";